import { defineMessages } from 'react-intl.macro';
import de from './translations/de.json';
import en from './translations/en.json';
import fr from './translations/fr.json';
import nl from './translations/nl.json';
import pl from './translations/pl.json';

const translations: Record<string, Record<string, string>> = {
  de,
  'de-DE': de,
  en,
  'en-GB': {},
  fr,
  nl,
  'nl-NL': nl,
  pl,
  'pl-PL': pl
};

export const appMessages = defineMessages({
  'app.add': {
    defaultMessage: 'Add',
    id: 'app.add'
  },
  'app.back': {
    defaultMessage: 'Back',
    id: 'app.back'
  },
  'app.cancel': {
    defaultMessage: 'Cancel',
    id: 'app.cancel'
  },
  'app.disabled': {
    defaultMessage: 'Disabled',
    id: 'app.disabled'
  },
  'app.enabled': {
    defaultMessage: 'Enabled',
    id: 'app.enabled'
  },
  'app.error': {
    defaultMessage: 'Error',
    id: 'app.error'
  },
  'app.isNumber': {
    defaultMessage: '{fieldName} has to be a number',
    id: 'app.isNumber'
  },
  'app.loading': {
    defaultMessage: 'Loading...',
    id: 'app.loading'
  },
  'app.maxLength': {
    defaultMessage: '{fieldName} cannot exceed {maxLength, number} {maxLength, plural, one {character} other {characters}}',
    id: 'app.maxLength'
  },
  'app.name': {
    defaultMessage: 'Work Management',
    id: 'app.name'
  },
  'app.nonBlank': {
    defaultMessage: '{fieldName} cannot be blank',
    id: 'app.nonBlank'
  },
  'app.ok': {
    defaultMessage: 'OK',
    id: 'app.ok'
  },
  'app.required': {
    defaultMessage: '{fieldName} is required',
    id: 'app.required'
  },
  'app.rowsPerPage': {
    defaultMessage: 'Rows per page',
    id: 'app.rowsPerPage'
  },
  'app.save': {
    defaultMessage: 'Save',
    id: 'app.save'
  },
  'app.tagLine': {
    defaultMessage: 'Advanced Configuration',
    id: 'app.tagLine'
  },
  'autocomplete.noResults': {
    defaultMessage: 'No results',
    id: 'autocomplete.noResults'
  },
  'autocomplete.tooManyResults': {
    defaultMessage: 'Too many results. Please narrow search.',
    id: 'autocomplete.tooManyResults'
  }
});

export default translations;
